var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1058 4.49828C11.3829 4.74074 11.411 5.16191 11.1685 5.439C10.9261 5.7161 10.5049 5.74417 10.2278 5.50172L8.66683 4.13585V10.6667C8.66683 11.0349 8.36835 11.3333 8.00016 11.3333C7.63197 11.3333 7.3335 11.0349 7.3335 10.6667V4.13585L5.7725 5.50172C5.49541 5.74417 5.07423 5.7161 4.83178 5.439C4.58932 5.16191 4.6174 4.74074 4.89449 4.49828L7.56116 2.16495C7.81251 1.94502 8.18782 1.94502 8.43917 2.16495L11.1058 4.49828ZM2.66683 10.6667C2.66683 10.2985 2.36835 10 2.00016 10C1.63197 10 1.3335 10.2985 1.3335 10.6667V12.6667C1.3335 13.403 1.93045 14 2.66683 14H13.3335C14.0699 14 14.6668 13.403 14.6668 12.6667V10.6667C14.6668 10.2985 14.3684 10 14.0002 10C13.632 10 13.3335 10.2985 13.3335 10.6667V12.6667H2.66683V10.6667Z",
    fill: "#2F4DC4",
    stroke: "#2F4DC4",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6efe783c028dc2c0f7d610e8df02b10e.svg";
export { ForwardRef as ReactComponent };